/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'resources': {
    width: 15,
    height: 15,
    viewBox: '0 0 15 15',
    data: '<g _fill="none" fill-rule="evenodd" _stroke="#008579"><path pid="0" d="M2.5 1.25h10M10.5 6.5v2h-6v-2"/><path pid="1" d="M1 4h13v10H1z"/></g>'
  }
})
